
import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Je_welryspelling } from "../../../../../Helpers/request";
import AboutUsImg from '../../../../../Assets/nokaoi-imges/about-us-img.png'
import { BorderColor } from "@material-ui/icons";

const AboutUs = () => {
  return (
    <section className="custom-design about_us_Section bg-white">
      <Container className="showcase-container" >
        <Row className="align-items-center">
          <Col md={6} xs={12} className="text-center">
            <Image src={AboutUsImg} className="img-fluid" alt="Custom Design Jewelry " />
          </Col>

          <Col md={6} xs={12}>
            <Heading className="text-left w-100">
              <span style={{ color: '#333' }} className="">About Us</span>

              <h2 className="mb-0 mt-1" tyle={{ color: '#333' }}>NO KA ʻOI Jewelers </h2>
              <p style={{ color: '#333' }} className="mb-3 mt-1">Maui’s Trusted Fine Jewelry store with over 30 years experience.</p>
              <p style={{ color: '#333' }} className="mb-3">
                <strong> At NO KA ʻOI Jewelers, we believe jewelry is more than just an accessory  </strong> – it’s a memory, a symbol, and a legacy.   Family-owned and locally operated in Kahului, Maui, we have proudly served Hawaii with fine jewelry, custom designs, engagement rings, and expert jewelry repair for over 25 years.   </p>
             
              <p style={{ color: '#333' }} className="mb-3"><strong> The Hawaiian phrase "No Ka ʻOi" means "the best" </strong> – and that’s exactly what we strive to deliver in every diamond, every design, and every customer experience.</p>
              <br></br>
           
              <div className="text-lg-left text-md-center text-center">
                <Link to="/our-story" className="btn outline-base-btn large bg-dark text-white text-uppercase" style={{ backgroundColor: '#333', border: "1px solid #333" }}>
                  Explore More
                </Link>
              </div>
            </Heading>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
